import { createReducer } from '@reduxjs/toolkit';
import { apiRequestSuccess } from 'services/api/api.actions';
import { getTopupAutomaticResourceId } from './rechargesAutomatic.config';
import { GetTopupAutomaticResponse } from './rechargesAutomatic.types';

type RechargesAutomaticState = {
  topupAutomaticObj: GetTopupAutomaticResponse['resultObject'] | null;
};

const initialState: RechargesAutomaticState = {
  topupAutomaticObj: null,
};

const rechargesAutomaticReducer = createReducer(initialState, (builder) => {
  builder.addCase(apiRequestSuccess, (state, action) => {
    const { payload } = action;

    switch (payload.resourceId) {
      case getTopupAutomaticResourceId:
        const response: GetTopupAutomaticResponse = payload.response.data;
        state.topupAutomaticObj = response.resultObject;
        return;
    }
  });
});

export default rechargesAutomaticReducer;
